import { useQuery } from '@tanstack/react-query';
import { services } from 'service';
import { DashStats, Stats } from 'types/general.type';

export const useGetActivities = () =>
  useQuery(['activities'], () => services.generalService.getActivities(), {
    refetchOnWindowFocus: false
  });

export const useGetAllocatedStat = () =>
  useQuery<Stats>(
    ['activities-stat'],
    () => services.generalService.getAllocatedStat(),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true
    }
  );

export const useGetDashboardStat = () =>
  useQuery<DashStats>(
    ['dashboard-stat'],
    () => services.generalService.getDashboardStat(),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true
    }
  );
